import React from "react";
import { connect } from "react-redux";

import { FlatMenuItems, DividerText } from "../../constants/Menu";
import { isServer } from "../../../utils";
import { DropdownBox } from "../../atoms/Dropdown/DropdownBox";
import { DropdownDivider } from "../../atoms/Dropdown/DropdownDivider";
import { DropdownItem } from "../../atoms/Dropdown/DropdownItem";
import { Block } from "../../atoms/Layout/Block/Block";
import { Text } from "../../atoms/Text/Text";
import { DesktopNavigation } from "./DesktopNavigation";
import { Analytics } from "../../services/Analytics/Analytics";

import styles from "./Navigation.css";

const DATA_ELEMENT_DESCRIPTION_SEARCH_TAG = "search tag button";

interface RootState {
  router: any;
}

class NavigationBase extends React.Component<{ pathname }> {
  static displayName = "Navigation";

  containerRef = React.createRef<any>();

  componentDidCatch(err, info) {
    console.log(err);
  }

  trackClick(category: string, index: number) {
    if (!isServer) {
      Analytics.trackEvent(Analytics.general.topNavClick(category, index));
    }
  }

  render() {
    return (
      <Block>
        <DesktopNav as="nav" ref={this.containerRef}>
          <DesktopNavigation
            renderDivider={this.renderDivider}
            onClick={this.trackClick}
          />
        </DesktopNav>

        <MobileNav as="nav" key="mobile">
          {this.renderMobileNav()}
        </MobileNav>
      </Block>
    );
  }

  renderMobileNav() {
    const urlSlug = this.props.pathname.split("/").slice(-1)[0];
    const selected =
      FlatMenuItems.find((item) => item.key === urlSlug) || FlatMenuItems[0];

    return (
      <MobileDropdown buttonText={selected.title} topOffset={2}>
        {FlatMenuItems.map((link, ind) => (
          <DropdownItem
            data-element-description={DATA_ELEMENT_DESCRIPTION_SEARCH_TAG}
            key={link.key}
            title={link.title}
            link={`/category/${link.key}`}
            onClick={() => this.trackClick(link.key, ind)}
          />
        ))}

        <DropdownItem
          data-element-description={DATA_ELEMENT_DESCRIPTION_SEARCH_TAG}
          key="help"
          title="Help"
          link="/help"
          onClick={() => this.trackClick("help", FlatMenuItems.length + 1)}
        />
      </MobileDropdown>
    );
  }

  renderDivider = (dividerItem: DividerText) => (
    <React.Fragment>
      <DropdownDivider />
      <DropdownItem noHover={true}>
        <Text as="div" size="xs" style={{ padding: "0.5em 0.5em 0" }}>
          {dividerItem}
        </Text>
      </DropdownItem>
    </React.Fragment>
  );
}

export const Navigation = connect((state: RootState) => ({
  pathname: state.router.location.pathname,
}))(NavigationBase);

const DesktopNav = React.forwardRef<any, any>((props: any, ref: any) => (
  <nav className={styles.desktopNavContainer} ref={ref} {...props} />
));
const MobileNav = (props: any) => (
  <div className={styles.mobileNavContainer} {...props} />
);
const MobileDropdown = (props: any) => (
  <DropdownBox className={styles.mobileDropdown} {...props} />
);
export const LinkText = (props: any) => (
  <Text className={styles.linkText} {...props} />
);
